const PROVIDER_MAP = {
  'googleplus': 'Google+',
  'facebook': 'Facebook',
  'microsoftaccount': 'Microsoft Account',
  'yahoo': 'Yahoo'
};

class SocialIconsLoaderService {

  constructor(controller) {

    this.controller = controller;

  }

  loadSocialIcons() {

    if (typeof window.janrain === 'object'
      && window.janrain.ready) {

      removeExistingJanrainCode();

    }

    if (typeof window.janrain !== 'object') window.janrain = {};
    if (typeof window.janrain.settings !== 'object') window.janrain.settings = {};

    window.janrainWidgetOnload = janrainWidgetOnload.bind(this);

    let janrain = window.janrain;

    /* _______________ can edit below this line _______________ */

    janrain.settings.tokenAction = 'event';
    janrain.settings.type = 'embed';
    janrain.settings.appId = 'bndkjabegaogfmanllak';
    janrain.settings.appUrl = 'https://login.efinancialcareers.com';
    janrain.settings.providers = ['googleplus', 'facebook', 'yahoo', 'microsoftaccount'];
    janrain.settings.providersPerPage = '4';
    janrain.settings.format = 'two column';
    janrain.settings.actionText = ' ';
    janrain.settings.showAttribution = false;
    janrain.settings.fontColor = '#666666';
    janrain.settings.fontFamily = 'Arial';
    janrain.settings.backgroundColor = 'transparent';
    janrain.settings.borderColor = 'transparent';
    janrain.settings.borderRadius = '0';
    janrain.settings.buttonBorderColor = '#ffffff';
    janrain.settings.buttonBorderRadius = '2px';
    janrain.settings.buttonBackgroundStyle = 'white';
    janrain.settings.language = '';
    janrain.settings.linkClass = 'janrainEngage';

    /* _______________ can edit above this line _______________ */

    janrain.ready = true;

    let e = document.createElement('script');
    e.type = 'text/javascript';
    e.id = 'janrainAuthWidget';

    if (document.location.protocol === 'https:') {
      e.src = 'https://rpxnow.com/js/lib/login.efinancialcareers.com/engage.js';
    } else {
      e.src = 'http://widget-cdn.rpxnow.com/js/lib/login.efinancialcareers.com/engage.js';
    }

    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(e, s);

  }

}

let removeExistingJanrainCode = function () {

  let rootScript = document.getElementById('janrainAuthWidget');
  if (rootScript) {
    rootScript.parentNode.removeChild(rootScript);
  }

  let additionalScript = document.querySelector('script[src*="widget-cdn"]');
  if (additionalScript) {
    additionalScript.parentNode.removeChild(additionalScript);
  }

  window.janrain = undefined;
  window.janrainWidgetOnload = undefined;

};

let janrainWidgetOnload = function () {

  let _this = this;

  window.janrain.events.onProviderLoginToken.addHandler(function(response) {

    _this.controller.setState({
      janrainToken: response.token,
      provider: PROVIDER_MAP[response.provider || _this.provider]
    });

    _this.controller.processSocialSignIn();

  });

  window.janrain.events.onProviderLoginSuccess.addHandler(function(response) {

    _this.provider = response.provider;

  });

};

export default SocialIconsLoaderService;



// WEBPACK FOOTER //
// ./src/library/services/SocialIconsLoaderService.js